import React, {useCallback, useEffect, useState} from 'react';
import OutboundGuildRequests from './OutboundGuildRequests.js';
import {setExploreToast} from 'actions/index.js';
import {connect} from 'react-redux';
import PotentialUser from './PotentialUser.js';
import ethereum from 'decentralized/ethereum.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import BackendQuery from 'decentralized/BackendQuery.js';
import GuildSamplesContract from 'decentralized/contracts/GuildSamplesContract.js';
import GuildSequencesContract from 'decentralized/contracts/GuildSequencesContract.js';
import {SampleCreated, NewGuildSequence} from 'decentralized/EthereumEvents.js';

const GuildDetails = ({guild, setExploreToast, numPending, onHide, onLeftGuild}) => {
    const [numSamples, setNumSamples] = useState(0);
    const [numSequences, setNumSequences] = useState(0);
    const [isInviting, setIsInviting] = useState(false);
    const [potentialUsers, setPotentialUsers] = useState([]);

    useEffect(() => {
        ethereum.encryption.getPotentialUsers()
            .then(async (users) => {
                let userNames = [];
                for (let user of users) {
                    userNames.push(await ethereum.users.getUserName(user));
                }
                setPotentialUsers(userNames.filter(x => x && x !== ''));
            });
    }, [setPotentialUsers]);

    useEffect(() => {
        if (guild === undefined) {
            return;
        }
        let query = new BackendQuery(new GuildSamplesContract().contractAddress)
            .from(SampleCreated)
            .select("ipfsHash")
            .where('guildId', guild.guildId);

        query.executeQuery()
            .then(r => setNumSamples(new Set(r.map(r => r.ipfsHash)).size));

        query = new BackendQuery(new GuildSequencesContract().contractAddress)
            .from(NewGuildSequence)
            .select("contentHash")
            .where('guildId', guild.guildId);

        query.executeQuery()
            .then(r => setNumSequences(new Set(r.map(r => r.contentHash)).size));

        setIsInviting(false);
    }, [guild, setNumSamples, setNumSequences, setIsInviting]);

    const inviteUser = useCallback((user) => {
        console.log('invite user =', user);
        // invite them
        ethereum.users.getUserId(user)
            .then(id =>  {
                ethereum.guilds.requestToAddMember(guild.guildId, id);
                setExploreToast("Invited " + user + " to " + guild.name);
            });
    }, [guild]);

    const leaveGuild = useCallback(() => {
        ethereum.guilds.leaveGuild(guild.guildId);
        onLeftGuild(guild);
        onHide();
    }, [guild, onHide]);

    if (guild === undefined) {
        return (
            <div></div>
        );
    }

    let members = guild.members.map(x => x.userName);
    return (
        <div className="guild-details">
          <ConditionedComponent condition={isInviting}>
            <div className="guild-members inviting">
              <div className="invite-header">Invite</div>
              <div className="people-container">
                {potentialUsers
                 .filter(user => members.indexOf(user) === -1)
                 .map(
                     user => 
                         <PotentialUser inviteUser={inviteUser} user={user}/>
                )}
              </div>
              <div onClick={() => setIsInviting(false)} className="cancel-button">
                Cancel
              </div>
            </div>
          </ConditionedComponent>
          <ConditionedComponent condition={!isInviting}>
            <div className="guild-members">
              <div className="members-header">
                Members
              </div>
              <div className="people-container">
                {guild.members.map(
                    member => <div className="member">{member.userName}</div>)}
              </div>
              <div
                onClick={() => setIsInviting(true)}
                className="invite-button">
                Invite
              </div>
            </div>
          </ConditionedComponent>
          <div className="guild-stats">
            <div className="samples-count">
              {numSamples} samples
            </div>
            <div className="samples-count">
              {numSequences} sequences 
            </div>
            <OutboundGuildRequests guild={guild}/>
            <div onClick={leaveGuild} className="leave-guild-btn">
              Leave Group
            </div>
          </div>
        </div>
    );
};

const mapDispatchToProps = (dispatch) => ({
    setExploreToast: (t) => dispatch(setExploreToast(t))
});

export default connect(null, mapDispatchToProps)(GuildDetails);
